import React, { useState, useEffect } from 'react';
import NewAssessment from './Dashboard/NewAssessment';
import AssessmentList from './AsmtListIntiator';
import { fetchUserAllAssessments, getAllParticipantsOfAssessment } from '../services/authService';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import AsmtListParticipants from './AsmtListParticipant';
import { encodeId } from '../utills/idUtils';

const StartAssessment = () => {
    const [assessments, setAssessments] = useState([]);
    const [participantAsmt, setParticipantsAsmt] = useState([]);
    const [isNewAssessment, setIsNewAssessment] = useState(false);
    const { state } = useAuth();
    const { user } = state;

    const userId = user?.user_id || null;
    const navigate = useNavigate();

    // ////console.log("user", user)
    // Load assessments based on user ID

    const loadAssessments = async (userId) => {

        try {
            const fetchedAsmts = await fetchUserAllAssessments(userId);
            setAssessments(fetchedAsmts.initiatorAssessments || []); // Fallback to an empty array
            setParticipantsAsmt(fetchedAsmts.participantAssessments || []); // Fallback to an empty array
        } catch (error) {
            console.error('Error loading assessments:', error.message);
        }
    };




    useEffect(() => {
        if (userId) {
            loadAssessments(userId);
        }
    }, [userId]);

    const handleStartNewAssessment = (assessment_id) => {
        const assessment = assessments.find(asmt => asmt.assessment_id === assessment_id);
        if (assessment) {
            if (assessment.assessment_type === 'self') {
                const encodedId = encodeId(assessment_id);
                navigate(`/self-asmt/${encodedId}`);
            } else if (assessment.assessment_type === '360') {
                const encodedId = encodeId(assessment_id);
                navigate(`/conn-asmt/${encodedId}`);
            }
        }
    };

    const handleStartNewAsmtForParticipants = async (assessment_id) => {
        if (!userId || !assessment_id) {
            alert("Both userId and assessment_id must be provided.");
            return;
        }

        const assessment = participantAsmt.find(asmt => asmt.assessment_id === assessment_id);
        if (assessment && assessment.association_type === 'participant') {
            const encodedId = encodeId(assessment_id);
            navigate(`/participant/${encodedId}`);
        } else {
            const encodedId = encodeId(assessment_id);
            navigate(`/report-details/${encodedId}`);
        }
    };

    if (isNewAssessment) {
        return <NewAssessment />;
    }

    return (
        <div>
            <div className="lg:flex lg:justify-between justify-center items-center mb-6 lg:pr-16">
                <h1  style={{ fontFamily: "Helvetica" }} className="text-2xl font-bold">My Assessment</h1>
                <button
                    className="bg-blue-600 text-white px-4 py-3 lg:my-0 rounded"
                    onClick={() => {
                        setTimeout(() => {
                            navigate("/start-asmt")
                        }, 1000);
                    }}
                >
                    Start New Assessment
                </button>

            </div>

            {/* {assessments.length === 0 && <p>No assessments found.</p>} */}
            <AssessmentList
                assessments={assessments}
                onStartNewAssessment={handleStartNewAssessment}
            />
            <br />
            {/* {participantAsmt.length === 0 && <p>No participant assessments found.</p>} */}
            <AsmtListParticipants
                assessments={participantAsmt}
                onStartNewAssessment={handleStartNewAsmtForParticipants}
            />
        </div>
    );
};

export default StartAssessment;
